import { render, staticRenderFns } from "./SearchBetgame.vue?vue&type=template&id=cc779a84&scoped=true"
import script from "./SearchBetgame.vue?vue&type=script&lang=js"
export * from "./SearchBetgame.vue?vue&type=script&lang=js"
import style0 from "./SearchBetgame.vue?vue&type=style&index=0&id=cc779a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc779a84",
  null
  
)

export default component.exports